module.exports = __webpack_public_path__ + "static/media/order-now-icon.46be1e3c.svg";